import { Image } from '@pcln/horizon'

import useMobileHeroAmenityImage from '@/hooks/useMobileHeroAmenityImage'
import useMobileHeroCityImage from '@/hooks/useMobileHeroCityImage'

export default function HeroMobile() {
  const mobileHeroCityImage = useMobileHeroCityImage()
  const mobileHeroAmenityImage = useMobileHeroAmenityImage()
  const mobileHeroImage = mobileHeroCityImage || mobileHeroAmenityImage

  return mobileHeroImage ? (
    <div className='m-4 max-h-[110px] overflow-hidden rounded-lg'>
      <Image
        src={mobileHeroImage.src}
        alt={`Picture of ${mobileHeroImage.altName}`}
        className='mobile-hero-image h-[131px] w-[393px] object-fill'
      />
    </div>
  ) : null
}
